<div class="upsell-mbg p-4">
  <div class="upsell-mbg__container max-w-container bg-lw-tan mx-auto p-4 desktop:py-8 desktop:px-16 flex flex-col-reverse desktop:flex-row items-center justify-center gap-6 rounded-lg">
    <div class="upsell-mbg__text max-w-lg text-base text-center desktop:text-left" [innerHTML]="displayMbgText"></div>
    <img class="upsell-mbg__image max-w-56 flex-shrink-0" [src]="mbgBadge">
    @if (mbgCTA) {
      <upsell-buttons [buttonYesText]="buttonYesText" [buttonNoText]="buttonNoText" (eventEmitter)="nextPage($event)"></upsell-buttons>
    }
  </div>

</div>
